var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconProcessingCheck = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4993 27.8564C22.0798 27.8564 28.3562 21.5801 28.3562 13.9995C28.3562 6.43254 22.0662 0.142578 14.4857 0.142578C6.91871 0.142578 0.642334 6.43254 0.642334 13.9995C0.642334 21.5801 6.9323 27.8564 14.4993 27.8564ZM12.6381 20.9687C12.1762 20.9687 11.8094 20.765 11.429 20.3031L7.50287 15.4667C7.2991 15.2086 7.17683 14.8826 7.17683 14.5837C7.17683 13.9452 7.67948 13.4561 8.29082 13.4561C8.6712 13.4561 9.01084 13.6055 9.3233 14.0267L12.5702 18.2245L18.8873 8.10352C19.1454 7.68238 19.4986 7.4786 19.8654 7.4786C20.4632 7.4786 21.0338 7.87257 21.0338 8.52466C21.0338 8.82354 20.8572 9.14958 20.6941 9.42129L13.7793 20.3031C13.4804 20.7514 13.1 20.9687 12.6381 20.9687Z",
    fill: "#A6FF79"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconProcessingCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-processing-check.ea112e0b500c2a57d9f07656cdd83da1.svg";